import { Analytics } from "@bounce/analytics"
import { Button, Caption } from "@bounce/design-system"
import { useTranslation } from "@bounce/i18n"
import { App } from "@bounce/util"

import { FloatingBanner } from "@/components/Generic/FloatingBanner/FloatingBanner"
import SafeLink from "@/components/Generic/SafeLink/SafeLink"
import { useAppFloatingBanner, useIsAppFloatingBannerVisible } from "@/contexts/AppFloatingBanner"
import { useAppStoreUrl } from "@/hooks/useAppStoreUrl"
import { InteractionEvents } from "@/libs/analytics/events"

import CloseIcon from "@bounce/assets/icons/Cross.svg"

export const AppFloatingBanner = () => {
  const { t } = useTranslation()
  const isVisible = useIsAppFloatingBannerVisible()
  const dismissBanner = useAppFloatingBanner(state => state.dismissBanner)
  const { href, onClick } = useAppStoreUrl({
    app: App.Customer,
    campaignName: "marketing-AppFloatingBanner",
    eventProps: {
      location: "AppFloatingBanner",
    },
  })

  const onClose = () => {
    Analytics.track(InteractionEvents.LuggageStorageAppStickyBannerDismissed, { variant: "floating" })
    dismissBanner()
  }

  return (
    <FloatingBanner isVisible={isVisible}>
      <div className="mx-4 mt-2 flex flex-row items-center rounded-lg bg-white px-2 py-3 shadow-3 md:hidden">
        <button onClick={onClose} aria-label={t("cmp.appFloatingBanner.close", "Close")}>
          <CloseIcon className="size-4 text-neutral-700" />
        </button>
        <div className="ml-2">
          <p className="title6 font-sans text-sm font-semibold">
            {t("cmp.appFloatingBanner.title", "Get the Bounce app")}
          </p>
          <Caption as="p" className="text-neutral-800">
            {t("cmp.appFloatingBanner.subtitle", "The easiest way to store bags")}
          </Caption>
        </div>
        <div className="ml-auto">
          <SafeLink href={href} onClick={onClick}>
            <Button onPress={null} size="small">
              {t("cmp.appFloatingBanner.button", "Use app")}
            </Button>
          </SafeLink>
        </div>
      </div>
    </FloatingBanner>
  )
}
